import React from "react";
import { FlexBox } from "components/common";
import { FacebookIcon, InstagramIcon, TwitterIcon } from "components/Icons";
import { Logo } from "components/Logo/Logo";
import styled from "styled-components";
import { FooterMenuItem } from "./FooterMenuItem";
import { SocialLink } from "components/SocialLink";

const Root = styled.div`
  background-color: ${props => props.theme.colors.basics.mostBlack};
`;

const Label = styled.div`
  font-size: 3rem;
  font-weight: ${props => props.theme.fontWeight.regular};
  color: ${props => props.theme.colors.primary.white};
`;

export const Footer = () => {
  return (
    <Root>
      <div className="container">
        <FlexBox gap="8rem" padding="6.7rem 0 7.5rem">
          <Logo height={71} />

          <FlexBox flexDirection="column" gap="1.6rem">
            <Label>Call us</Label>
            <Label>913.732.7864</Label>
          </FlexBox>

          <FlexBox flexDirection="column" gap="1.6rem">
            <FooterMenuItem label="Home" targetId="/#splash" />
            <FooterMenuItem label="What we offer" targetId="/#what-we-offer" />
            <FooterMenuItem label="Our work" targetId="/#our-work" />
            <FooterMenuItem label="Our team" targetId="/#our-team" />
          </FlexBox>

          <FlexBox flexDirection="column" gap="1.6rem">
            <FooterMenuItem label="Testimonials" targetId="/#our-saying" />
            <FooterMenuItem label="Contact us" targetId="/#contact-us" />
            <FooterMenuItem label="Research" targetId="research" />
            <FooterMenuItem label="Blog" targetId="http://blog.joviantechnologies.io" />
          </FlexBox>

          <FlexBox gap="1.6rem">
            <SocialLink
              url="https://facebook.com"
              icon={<FacebookIcon />}
              color="#fff"
            />
            <SocialLink
              url="https://twitter.com"
              icon={<TwitterIcon />}
              color="#fff"
            />
            <SocialLink
              url="https://instagram.com"
              icon={<InstagramIcon />}
              color="#fff"
            />
          </FlexBox>
        </FlexBox>
      </div>
    </Root>
  );
};
